import React, { FunctionComponent } from 'react';
import type { TvDetail } from '../../../types/tvShow';

type Props = {
  tv: TvDetail;
};

export const Presentation: FunctionComponent<Props> = ({
  tv,
}) => {
  const isCustomButton = tv.buttonName && tv.buttonUrl;
  const isCompanyButton = !isCustomButton && tv.companyId;

  return (
    <div className="tv-content-middle">
      <div
        className="tv-content-middle-about"
        dangerouslySetInnerHTML={{ __html: tv.body }}>
      </div>
      <div className="tv-content-middle-link">
        {isCustomButton && (
          <a
            href={tv.buttonUrl ?? '#'}
            className="button button-yellow tv-content-middle-link-button gtm-button-view-count"
            target="_blank"
            rel="noopener noreferrer"
            data-event-name='button on screen'
            data-event="click"
            data-category="tvcontent"
            data-value="cv_set_url"
          >
            {tv.buttonName}
          </a>
        )}
        {isCompanyButton && (
          <a
            href={`/recruitments/company/${tv.companyId}`}
            className="button button-yellow tv-content-middle-link-button gtm-button-view-count"
            data-event-name='button on screen'
            data-event="click"
            data-category="tvcontent"
            data-value="cv_company_recruitments"
          >
            この企業の求人を見る
          </a>
        )}
      </div>
    </div>
  );
};
